/*
 * @Author: tangf tangf_86@163.com
 * @Date: 2024-03-26 13:52:11
 * @LastEditors: tangf tangf_86@163.com
 * @LastEditTime: 2024-05-29 11:14:31
 * @FilePath: \hippo-web-admin\src\utils\utils.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// import Dayjs from '@/vendor/dayjs.min'
import { BLOOD_SUGAR_UNIT, USER_LOGIN_TYPE } from '@/config/setting';
import moment from 'moment-timezone';
const theme = process.env.VUE_APP_THEME || 'furCarer';

export const Dayjs = require('dayjs');
const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone'); // dependent on utc plugin
Dayjs.extend(utc);
Dayjs.extend(timezone);

/**
 * 获取文件服务访问路径
 * @param url
 * @param subStr
 * @returns {*}
 */
export function getFileAccessHttpUrl(url, subStr) {
  if (!subStr) subStr = 'http';
  try {
    if (url && url.startsWith(subStr)) {
      return url;
    } else {
      if (url && url.length > 0 && url.indexOf('[') == -1) {
        return process.env.VUE_APP_URL + url;
      } else {
        return '';
      }
    }
  } catch (err) {
    return;
  }
}

export const formatToDate = (timestamp, format = 'YYYY-MM-DD hh:mm:ss') => {
  if (!timestamp) {
    return '';
  }
  window.Dayjs = Dayjs;
  return Dayjs.utc(timestamp).format(format);
};

// order -1 取当前时区 1 取utc
export const formatToDate2 = (
  timestamp,
  format = 'YYYY-MM-DD hh:mm:ss',
  order = 1
) => {
  const localTime = new Date(timestamp);
  if (!timestamp) {
    return '';
  }
  return Dayjs.utc(
    localTime.getTime() + localTime.getTimezoneOffset() * 60000 * order
  ).format(format);
};

export const parseUnit = (value, unit = 'mmol/L') => {
  let realValue = 0;
  if (value) {
    realValue = value;
    if (unit.toLocaleLowerCase().indexOf('mg/dl') > -1) {
      realValue = Math.floor(value * 18);
    }
  }
  return realValue;
};

/**
 * 深拷贝
 */
export const deepClone = (o) => {
  // 要判断o是对象还是数组
  if (Array.isArray(o)) {
    // 数组
    var result = [];
    for (var i = 0; i < o.length; i++) {
      result.push(deepClone(o[i]));
    }
  } else if (typeof o == 'object') {
    // 对象
    var result = {};
    for (var k in o) {
      result[k] = deepClone(o[k]);
    }
  } else {
    // 基本类型值
    var result = o;
  }
  return result;
};

/**
 * 系统中 mmol/L 和 mg/d的转换
 */
export const parseUnitToMgDl = (value) => {
  value = value ?? 0;
  //  mmol/L  mg/d
  const unit = localStorage.getItem(BLOOD_SUGAR_UNIT) || 'mmol/L';
  value = parseFloat(value);
  const result =
    unit.toLocaleLowerCase().indexOf('mmol/l') > -1
      ? value
      : Math.floor(value * 18).toFixed(2);
  return {
    value: parseFloat(result),
    unit
  };
};

/**
 * 判断当前系统中登录的用户角色
 */
export const isCgm = () => {
  const loginType = localStorage.getItem(USER_LOGIN_TYPE);
  return String(loginType) === '2';
};

// 计算某一个时间到当前时间间隔多少天
export const calculateDays = (startTime, endTime) => {
  const currentTime = new Date(endTime).getTime();
  const targetTime = new Date(startTime).getTime();
  const diffTime = currentTime - targetTime;
  const diffDays = (diffTime / (1000 * 60 * 60 * 24)).toFixed(1);
  return diffDays;
};

// 每日血糖数据排序
export const changeDataSort = (data) => {
  // 更改data的排序，根据第一个数据来排序后面的数据
  const temp = data[0]?.bloodSugarPoints[0]?.time;
  for (let i = 1; i < data.length; i++) {
    const index = data[i]?.bloodSugarPoints.findIndex(
      (item) => item.time === temp
    );
    if (index > -1) {
      data[i]?.bloodSugarPoints.unshift(
        ...data[i]?.bloodSugarPoints.splice(
          index,
          data[i]?.bloodSugarPoints?.length
        )
      );
    }
  }
  // const index = data.findIndex(item => item.bloodSugarPoints[0]?.time === '00:00')

  // if (index > -1) {
  //   data.unshift(...data.splice(index, 1))
  // }
};

// 获取一整天的时间数据数组，从00:00开始,到23:59结束,每隔3分钟一次；例如 ['00:00', '00:03', .... , '23:57']
export const getAllDayTime = (begin = 0, end = 24) => {
  const result = [];
  for (let i = begin; i < end; i++) {
    for (let j = 0; j < 60; j += 1) {
      const hour = i < 10 ? '0' + i : i;
      const minute = j < 10 ? '0' + j : j;
      result.push(`${hour}:${minute}`);
    }
  }
  result.push(`${end}:00`);
  // // 移除最后一条记录替换为 00:00
  // result.pop();
  // // 最后添加 00:00 到数组中
  // result.push('00:00');
  return result;
};
export const getAllDayTimeSame = (begin = 0, end = 24) => {
  const result = [];
  for (let i = begin; i < end; i++) {
    for (let j = 0; j < 60; j += 1) {
      const hour = i < 10 ? '0' + i : i;
      const minute = j < 10 ? '0' + j : j;
      result.push(`${hour}:${minute}`);
    }
  }
  result.push(`${end}:00`);
  // 移除最后一条记录替换为 00:00
  result.pop();
  // 最后添加 00:00 到数组中
  result.push('00:00');
  return result;
};
/**
 *获取几个月前的输入日期
 *{param:DateTime} date 输入日期(YYYY-MM-DD)
 *{param:number } monthNum 月数
 */
export const GetPreMonthDay = (date, monthNum) => {
  var dateArr = date.split('-');
  var year = dateArr[0]; //获取当前日期的年份
  var month = dateArr[1]; //获取当前日期的月份
  var day = dateArr[2]; //获取当前日期的日
  var days = new Date(year, month, 0);
  days = days.getDate(); //获取当前日期中月的天数
  var year2 = year;
  var month2 = parseInt(month) - monthNum;
  if (month2 <= 0) {
    var absM = Math.abs(month2);
    year2 =
      parseInt(year2) - Math.ceil(absM / 12 == 0 ? 1 : parseInt(absM) / 12);
    month2 = 12 - (absM % 12);
  }
  var day2 = day;
  var days2 = new Date(year2, month2, 0);
  days2 = days2.getDate();
  if (day2 > days2) {
    day2 = days2;
  }
  if (month2 < 10) {
    month2 = '0' + month2;
  }
  var t2 = year2 + '-' + month2 + '-' + day2;
  return t2;
};

/**
 * @param {number} date
 * @returns {string}
 */
export function formatTimeStr(date) {
  const now = new Date();
  const seconds = (now - new Date(date)) / 1000;

  if (seconds < 60 * 60) {
    return `${Math.floor(seconds / 60)}`;
  } else if (seconds < 60 * 60 * 24) {
    return `${Math.floor(seconds / (60 * 60))}`;
  } else {
    return `${Math.floor((now - new Date(date)) / (60 * 60 * 24 * 1000))}`;
  }
}
export const DAY_ALL_TIME = getAllDayTime();
export const XAXIS_TIME = getAllDayTimeSame();

// 获取当前0时区时间
export const formatNowUtc = () => {
  const now = new Date();
  const year = now.getUTCFullYear();
  let month = now.getUTCMonth() + 1; // 月份从0开始，需要加1
  month < 10 ? (month = '0' + month) : month;
  let day = now.getUTCDate();
  day < 10 ? (day = '0' + day) : day;
  let hours = now.getUTCHours();
  hours < 10 ? (hours = '0' + hours) : hours;
  let minutes = now.getUTCMinutes();
  minutes < 10 ? (minutes = '0' + minutes) : minutes;
  let seconds = now.getUTCSeconds();
  seconds < 10 ? (seconds = '0' + seconds) : seconds;
  const utcTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  return utcTime;
};

/**
 * 将时间转换为指定格式的时间字符串
 * @param {Date} date - 输入的时间对象
 * @param {string} timezone - 时区字符串，例如 'Asia/Shanghai'
 * @returns {string} 格式化后的时间字符串，例如 '2021-07-23T15:30:00+08:00'
 */
export function getUtcTime(date, timeZones) {
  if (!date) return '';
  let timeZone = '';
  if (timeZones) {
    timeZone = timeZones;
  } else {
    timeZone = localStorage.getItem('TimeZone_byhippo') || 'Asia/Shanghai';
  }
  let zStr = moment(date).tz(timeZone).format('Z');
  return (
    formatDateTime('YYYY-MM-DD', new Date(date)) +
    ' ' +
    formatDateTime('HH:mm', new Date(date)) +
    zStr
  );
  // return theme == 'furCarer' ? moment(date).tz(timeZone).format('YYYY-MM-DDTHH:mmZ') : moment(date).tz(timeZone).format('YYYY-MM-DD HH:mmZ');
}

// 获取时区的偏移量
export function getTimeZ(timeZones) {
  let timeZone = '';
  if (timeZones) {
    timeZone = timeZones;
  } else {
    timeZone = localStorage.getItem('TimeZone_byhippo') || 'Asia/Shanghai';
  }
  return moment().tz(timeZone).format('Z');
}

// 获取时区的偏移量
export function getTimeZForAr(timeZones) {
  const timeZ = getTimeZ(timeZones).replace('+', '');
  return timeZ + '+';
}

// 将时区时间转成utc时间
export function toUtcTime(date, format = 'YYYY-MM-DD HH:mm:ss', timeZones) {
  let timeZone = '';
  if (timeZones) {
    timeZone = timeZones;
  } else {
    timeZone = localStorage.getItem('TimeZone_byhippo') || 'Asia/Shanghai';
  }
  let getDiffTime = this.getTimeZ(timeZone);
  let diffTime = getDiffTime
    .split(':')[0]
    .slice(1, getDiffTime.split(':')[0].length);
  let times = '';
  if (getDiffTime.includes('+')) {
    times = formatDateTime(
      format,
      new Date(date).getTime() - Number(diffTime) * 60 * 60 * 1000
    );
  } else {
    times = formatDateTime(
      format,
      new Date(date).getTime() + Number(diffTime) * 60 * 60 * 1000
    );
  }
  return times;
}

/** 根据时区转出时间 */
export function getUtcFTime(date, dateType = 'YYYY-MM-DD HH:mm:ss', timeZones) {
  if (!date) return '';
  date = new Date(date).getTime();
  let timeZone = '';
  if (timeZones) {
    timeZone = timeZones;
  } else {
    timeZone = localStorage.getItem('TimeZone_byhippo') || 'Asia/Shanghai';
  }
  return formatDateTime(dateType, moment(date).tz(timeZone)._d);
}

/**
 * 获取年月日时分秒
 * @param date {Date}
 * @return {{month: number, year: number, day: number}}
 */
export const getYmdHms = (date = new Date()) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const min = date.getMinutes();
  const sec = date.getSeconds();
  return { year, month, day, hour, min, sec };
};

/**
 * @description 数字格式化几位数 前面补0
 * @param digit {number} 几个位
 * @param number {number||string} 要格式化到数字
 * @return {string} 格式化后的数字
 * @example
 *
 * 		formatNum(3, 5); // => '005'
 *
 */
export const formatNum = (digit, number) => {
  const numArr = (number + '').split('');
  const length = numArr.length;
  if (length >= digit) {
    return numArr.slice(length - digit).join('');
  } else {
    const add = new Array(digit - length).fill(0);
    return add.concat(numArr).join('');
  }
};

/**
 * 时间格式化
 * @param {number || Date} date 时间戳 || 时间对象
 * @param {string} dateType 要得到的时间格式
 * @return {string} 格式化后的时间
 */
export const formatDateTime = (dateType, date = new Date()) => {
  if (typeof date === 'string') {
    date = Number(date);
  }
  date = new Date(date);
  let resultTime = null; //要返回出去的时间
  if (!date || !dateType) {
    throw new Error('传入的时间戳有误或没有传入dateType');
  } else {
    const { year, month, day, hour, min, sec } = getYmdHms(date);
    resultTime = dateType.replace('YYYY', String(year));
    resultTime = resultTime.replace('MM', formatNum(2, month));
    resultTime = resultTime.replace('DD', formatNum(2, day));
    resultTime = resultTime.replace('HH', formatNum(2, hour));
    resultTime = resultTime.replace('mm', formatNum(2, min));
    resultTime = resultTime.replace('ss', formatNum(2, sec));
  }
  return resultTime;
};

// "2025-05-06 17:34:08",
// '\u202A'+this.getTimeZForAr(this.timeZone)+' '+'\u202C'+ '\u202B'+ this.getUtcFTime(item.recordTime, 'YYYY-MM-DD HH:mm', this.timeZone)+ '\u202C':
// this.getUtcFTime(item.recordTime, 'YYYY-MM-DD HH:mm', this.timeZone) + ' '+this.getTimeZ(this.timeZone)
export const date2TimeZone = (
  dateTime,
  timeFormat = 'YYYY-MM-DD HH:mm',
  timeZone = '',
  isAr = false
) => {
  if (isAr) {
    return (
      '\u202A' +
      getTimeZForAr(timeZone) +
      ' ' +
      '\u202C' +
      '\u202B' +
      getUtcFTime(dateTime, timeFormat, timeZone) +
      '\u202C'
    );
  }
  const timeZoneString =
    getUtcFTime(dateTime, timeFormat, timeZone) + ' ' + getTimeZ(timeZone);
  return timeZoneString;
};

export const adjustShowUnitValue = (
  value1,
  value2,
  isAr = false,
  linkChar = ' '
) => {
  if (!isAr) {
    return '\u202A'+value1 + linkChar + value2+'\u202C';
  } else {
    return  '\u202A'+value2+'\u202C'+ '\u202A'+ linkChar +'\u202C'+'\u202A'+ value1+'\u202C';
  }
};

export const getFormattedValue = (value, isAr, unit = '%') => {
  if (Array.isArray(value)) {
    // 如果是范围值（如 [25, 75]）
    return isAr
      ? `${unit}${value[1]}-${unit}${value[0]}` // 阿拉伯语环境，反转顺序
      : `${value[0]}${unit}-${value[1]}${unit}`; // 非阿拉伯语环境，正常顺序
  } else {
    // 如果是单个值（如 50）
    return isAr ? `${unit}${value}` : `${value}${unit}`; // 根据语言调整单位位置
  }
};
 

export const toLocalDate = (date) => {
  if (!date) return new Date();
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

// function toLocalDate(date) {
//   if (!date) return new Date();
//   const d = new Date(date);
//   d.setHours(0, 0, 0, 0);
//   return d;
// }
// export function getLocalDate(date) {
//   const localDate = toLocalDate(date);
//   return formatDateTime('YYYY-MM-DD', localDate);
// }